import * as routePaths from '../consts/route/routePaths';
import useIsPage from './useIsPage';

const useIsErrorPage = () => {
    const isErrorPage = useIsPage(routePaths.ERROR_PAGE);

    return isErrorPage;
};

export default useIsErrorPage;
